import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import MailingListSignup from './components/MailingListSignup';
import AboutUs from './components/AboutUs';
import WhyJoinNow from './components/WhyJoinNow';
import EventsUpdates from './components/EventsUpdates';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <AboutUs />
      <WhyJoinNow />
      <MailingListSignup />
      <EventsUpdates />
      <Footer />
    </div>
  );
}

export default App;
